export default "__VITE_ASSET__DGIBd864__"